import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/home/" element={<Navigate to="/" replace />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/privacy-policy" element={<Navigate to="/legal/privacy" replace />} />
          <Route path="/terms-of-use" element={<Navigate to="/legal/terms" replace />} />
          <Route path="/terms" element={<Navigate to="/legal/terms" replace />} />
          <Route path="/refund-policy" element={<Navigate to="/legal/refund" replace />} />
          <Route path="/disclaimer" element={<Navigate to="/legal/refund" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
